module.exports = __webpack_public_path__ + "img/remove.2b644bd0.svg";